/**
 * 前端主题色（antd 侧的唯一取值来源）。
 *
 * 双写约定：
 * - CSS 侧权威令牌在 `src/styles/09-parity-tokens-shell.css` 的 `:root`（视觉真正生效的地方）
 * - antd 运行时主题在 `src/main.tsx` 的 `ConfigProvider.theme`
 *
 * 两处必须逐值一致；由 `theme-tokens.test.ts` 守护，改配色时漏改一侧会直接测试失败。
 */
export const themeTokens = {
  /** 主色：现代靛蓝 */
  primary: '#4c6ef5',
  /** 主色 hover / 深蓝 */
  primaryStrong: '#3b5bdb',
  success: '#2f9e67',
  /** 强调/警示琥珀 */
  warning: '#e8942f',
  danger: '#e5564c',
  info: '#3b7ddd',
  text: '#1f2a37',
  textSecondary: '#4b5563',
  border: '#e4e7ec',
  bgLayout: '#f7f8fa',
  bgContainer: '#ffffff',
} as const;
